import { render, staticRenderFns } from "./AwardsTabSection.vue?vue&type=template&id=b0e868dc&scoped=true"
import script from "./AwardsTabSection.vue?vue&type=script&lang=js"
export * from "./AwardsTabSection.vue?vue&type=script&lang=js"
import style0 from "./AwardsTabSection.vue?vue&type=style&index=0&id=b0e868dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e868dc",
  null
  
)

export default component.exports